"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const FallbackAppBar_1 = tslib_1.__importDefault(require("./components/FallbackAppBar/FallbackAppBar"));
const MenuDrawer_1 = tslib_1.__importDefault(require("./compositions/MenuDrawer"));
const menuTheme_1 = require("./utils/menuTheme");
const getLogoSrc = (items) => {
    const item = items.find((x) => x.kind === "logo");
    return item?.large?.imgSrc ?? "";
};
/**
 *
 *
 * @category component
 */
const ArgusMenu = ({ children, headerSize, ...props }) => {
    const { menuTheme, parentTheme } = (0, menuTheme_1.useMenuTheme)();
    const config = props;
    // If "user item" don't have any label, the user is unauthenticated.
    if (config?.items?.find((x) => x.kind === "user")?.label)
        return (react_1.default.createElement(material_1.ThemeProvider, { theme: menuTheme },
            react_1.default.createElement(MenuDrawer_1.default, { config: config, children: 
                // We don't want to override the theme for the children, so we set this back to the parent theme.
                react_1.default.createElement(material_1.ThemeProvider, { theme: parentTheme }, children), headerSize: headerSize })));
    return react_1.default.createElement(FallbackAppBar_1.default, { children: children, logoSrc: getLogoSrc(props?.items) });
};
exports.default = ArgusMenu;
